"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const EBecropController_1 = __importDefault(require("../Types/EBecropController"));
const MixpanelHandler_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MixpanelHandler"));
let Order = class Order extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.finishStep = false;
        this.initAnimationCompleted = false;
        this.twoStep = false;
        this.secontStep = false;
        this.mixpanelHandler = new MixpanelHandler_1.default();
        this.recomendationsAccess = false;
    }
    resetCheckRecommendations() {
        this.recomendationsAccess = false;
    }
    get currentFieldValid() {
        if (this.eBecropController.currentField) {
            if (this.eBecropController.currentField.recSet.recommendations.length < 1 && this.hasEbecropDiagnosticPassed(this.eBecropController.currentField) && this.eBecropController.currentField.recomendationsBrief === 'has_recommendations') {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    hasEbecropDiagnosticPassed(field) {
        if (!field.eBeCropDiagnostic.acreage)
            return false;
        if (!field.eBeCropDiagnostic.region)
            return false;
        if (!field.eBeCropDiagnostic.crop)
            return false;
        return true;
    }
    expandOrderPanel() {
        if (this.eBecropController.orderPanelExpand)
            this.secontStep = true;
        else
            this.secontStep = false;
    }
    toggleRecomendationsAccess() {
        this.recomendationsAccess = !this.recomendationsAccess;
    }
    dismissStep() {
        this.secontStep = false;
        if (this.finishStep) {
            this.eBecropController.updateOrder(true);
        }
        this.initAnimationCompleted = true;
    }
    changeStep() {
        this.secontStep = true;
        this.initAnimationCompleted = true;
    }
    orderBecrop() {
        if (this.finishStep) {
            this.eBecropController.updateOrder(true);
        }
        else if (this.secontStep) {
            this.eBecropController.orderBecrop(this.eBecropController.filteredState.state, this.dataOrder.coordinates, this.dataOrder.geodata, this.dataOrder.hectares, this.user.email, this.eBecropController.currentField ? this.eBecropController.currentField.name.toString() : '---', this.eBecropController.currentField ? this.eBecropController.currentField.id : 0, this.recomendationsAccess);
            this.finishStep = true;
        }
        this.mixpanelHandler.trackEvent('order eBecrop', {
            state: this.eBecropController.filteredState.state.length > 0
                ? this.eBecropController.filteredState.state
                : 'No specific area',
            metric: this.eBecropController.filteredState.crop.name.length > 0
                ? this.eBecropController.filteredState.crop.name
                : 'No specific crop',
            crop: this.eBecropController.filteredState.metric.length > 0
                ? this.eBecropController.filteredState.metric
                : 'No specific metric',
        });
        this.initAnimationCompleted = true;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: new EBecropController_1.default() })
], Order.prototype, "eBecropController", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null })
], Order.prototype, "dataOrder", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Order.prototype, "user", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('eBecropController.currentField')
], Order.prototype, "resetCheckRecommendations", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('eBecropController.orderPanelExpand')
], Order.prototype, "expandOrderPanel", null);
Order = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Button: bmk_ui_framework_1.Button,
            ArrowRight: lucide_vue_next_1.ArrowRight,
            TubeIcon: bmk_ui_framework_1.TubeIcon,
            XAloneIcon: bmk_ui_framework_1.XAloneIcon,
            CheckRoundedIcon: bmk_ui_framework_1.CheckRoundedIcon,
            CheckBox: bmk_ui_framework_1.CheckBox
        },
    })
], Order);
exports.default = Order;
